import { render, staticRenderFns } from "./ContributionsLable.vue?vue&type=template&id=5f3be6c0"
import script from "./ContributionsLable.vue?vue&type=script&lang=js"
export * from "./ContributionsLable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports